import React from 'react'


import Img from 'gatsby-image'

const Testimonial = (props) => {
    return (

        <section className="uk-cover-container overlay-wrap">
			
            <Img
                    sizes={props.foto}
                    style={{
                        top: 0,
                        left: 0,
                        position: 'absolute',
                        objectFit: 'cover',
                        height: '100%',
                        width: '100%'
                    }}
                    imgStyle={{
                        objectPosition: 'center center',
                    }}
                />
			<div className="uk-container uk-position-z-index uk-position-relative uk-section uk-section-xlarge uk-light">
				<div className="uk-grid uk-flex-right">
					
					<div className="uk-width-2-5@m" data-uk-parallax="y: 50,-50; easing: 0; media:@l">
						<h5>LE NOSTRE COPPIE FELICI</h5>
						<div className="uk-position-relative uk-visible-toggle uk-light" data-uk-slider="easing: cubic-bezier(.16,.75,.47,1)">
							<ul className="uk-slider-items uk-child-width-1-1">
								<li>
									<div data-uk-slider-parallax="opacity: 0.2,1,0.2">
										<h2 className="uk-margin-small-top">"Con Prowedding siamo andati sul sicuro. Servizio fotografico perfetto!"</h2>
										<p className="uk-text-meta">Anna e Angelo</p>
									</div>
								</li>
								<li>
									<div data-uk-slider-parallax="opacity: 0.2,1,0.2">
										<h2 className="uk-margin-small-top">"Il nostro fotografo è diventato un amico... grazie Prowedding"</h2>
										<p className="uk-text-meta">Lorena e Marco</p>
									</div>
								</li>
								<li>
									<div data-uk-slider-parallax="opacity: 0.2,1,0.2">
										<h2 className="uk-margin-small-top">"Abbiamo fatto vedere il video e le foto agli amici e non vedono l'ora di sposarsi anche loro"</h2>
										<p className="uk-text-meta">Antonella e Giorgio</p>
									</div>
								</li>
							</ul>
							<ul className="uk-slider-nav uk-dotnav uk-margin-top"><li></li></ul>
							
						</div>
					</div>
					
				</div>
			</div>
		</section>


    )
}

export default Testimonial


// WEBPACK FOOTER //
// ./src/components/homepage/testimonial/index.js